;(function($, undefined){

    var rnn;
    rnn = window.rnn;

    function progressBar($container) {
        // this html covers both bootstrap 2 and 3
        $container.html('<div class="progress progress-striped active">' +
                        '<div class="bar progress-bar progress-bar-striped active" style="width: 100%;" role="progressbar" aria-valuenow="100"></div>' +
                        '</div>');
    }

    function getSavedData($container, $parent, callback, error) {
        $.ajax({
            dataType: 'json',
            url: rnn.site.follow.viewUsersURL,
            success: function (data) {
                $container.find('.progress').remove();
                if (_.isFunction(callback)) {
                    callback(data);
                }
            },
            error: function(jqXHR, textStatus, errorThrown) {
                $container.find('.progress').remove();
                $parent.addClass('error');
                if (_.isFunction(error)) {
                    error();
                }
            }
        });
    }

    function initProfileUsersFollowing() {
        var $fragmentEmpty = $('.userFollowingPane').find('.userFollowingEmpty');
        var $fragmentIntro = $('.userFollowingPane').find('.userFollowingIntro');
        if ($('.userFollowingPane').find('.action').length === 0 && $fragmentEmpty.is(':hidden')) {
            var $container = $('.userFollowingPane .actions');
            var $parent = $('.userFollowingPane');

            progressBar($container);
            getSavedData($container, $parent, function (data) {
                if (data.subscriptions.length > 0) {
                    $fragmentIntro.removeClass('hide');
                    var source = $('#hdlbars-accounts-usersFollowing').html();
                    if (source) {
                        var template = Handlebars.compile(source);
                        var html = '';
                        var selectedMonth = '';

                        _.each(data.subscriptions, function (value, index, list) {
                            html += template(value);
                        });
                        html += '</div>';

                        // setup time stamps and delete click events
                        $container.html(html)
                                  .find('abbr.pubDate')
                                  .timeago()
                                  .end()
                                  .find('.btn-delete').on('click', function (e) {
                                    e.preventDefault();
                                    deleteAccountSearch($(this));
                                  })
                                  .parent('.action-btns').siblings('.notification-settings').find('.email-notifications-btn').on('click', function (e) {
                                    e.preventDefault();
                                    saveEmailNotificationSetting($(this));
                                  });
                    }
                } else {
                    // if theres no results show the fragment
                    $container.find('.progress').remove();
                    $fragmentEmpty.removeClass('hide');
                }

            }, function () {
                $fragmentEmpty.removeClass('hide');
                rnn.modules.notifications.error("There was a problem loading the users you're following, please try again.");
            });
        }
    }

    function deleteAccountSearch($search) {
        var url = $search.data('url');

        $search.html('Deleting...');
        $.ajax({
            url: url,
            type: 'POST',
            success: function (data) {
                if (data.message.length === 0) {
                    var $btns = $search.closest('.action-btns');
                    var $getUserTag = $btns.parent().prev('.action').children('a').attr('title');

                    $('#my-profile-tab .following').find('.following-user[title="' + $getUserTag + '"]').remove();

                    $btns.parent().prev('.action').remove();
                    $btns.parent().remove();

                    rnn.modules.notifications.info("<strong>Delete successful.</strong> You're no longer following this user.");
                    if ($('.userFollowingPane .action').length === 0) {
                        $('.userFollowingPane .userFollowingEmpty').removeClass('hide');
                        $('.userFollowingPane .userFollowingIntro').addClass('hide');
                    }
                } else {
                    rnn.modules.notifications.error('There was a problem deleting this user, please try again');
                    $search.html('<i class="icomoon-icon icon-bin"></i>');
                }
            }
        });
    }

    function saveEmailNotificationSetting($emailBtn) {
        var url = $emailBtn.data('url');
        var emailNotifications = $emailBtn.data('email-notifications');
        var formData = '';

        emailNotifications = emailNotifications ? false : true;
        formData = 'receive_email_notifications=' + emailNotifications;

        $.ajax({
            url: url,
            data: formData,
            type: 'POST',
            success: function (response) {
                if (response.message.length === 0) {
                    if (emailNotifications) {
                        rnn.modules.notifications.info('<strong>Subscribed.</strong> You will now receive email updates relating to this topic.');
                    } else {
                        rnn.modules.notifications.info('<strong>Unsubscribed.</strong> You will no longer receive email updates relating to this topic.');
                    }
                    $emailBtn.toggleClass('button-default-dark').toggleClass('button-default-border');
                    $emailBtn.data('email-notifications', response.receive_email_notifications);
                } else {
                    rnn.modules.notifications.error('There was a problem updating your email notification settings, please refresh and try again');
                }
            }
        });
    }

    function initSavedSearch() {
        if ($('#my-account-container #notifications-tab').length) {
            initProfileUsersFollowing();
        }
    }

    rnn.modules.register('usersFollowing', {
        init: initSavedSearch
    });

})(jQuery);